import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';
import { Toaster } from '../ui/sonner';
import { useSync } from '../../contexts/SyncContext';
import { Loader2 } from 'lucide-react';

const SyncBanner = () => {
  const { isSyncing } = useSync();
  if (!isSyncing) return null;
  return (
    <div className="fixed bottom-20 md:bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 bg-primary text-primary-foreground text-sm font-medium px-4 py-2 rounded-full shadow-lg">
      <Loader2 className="w-4 h-4 animate-spin" />
      Synchronisation en cours…
    </div>
  );
};

export const Layout = ({ children }) => {
  return (
    <div className="flex h-screen overflow-hidden bg-background" data-testid="app-layout">
      <Sidebar />
      <main className="flex-1 p-4 md:p-8 overflow-y-auto pb-24 md:pb-8">
        {children}
      </main>
      <BottomNav />
      <Toaster position="top-right" />
      <SyncBanner />
    </div>
  );
};
